module.exports = __webpack_public_path__ + "img/arrow-rotate.f047fad8.svg";